import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralize } from "@common/helpers/string";
import { displayAccountLabel } from "@common/helpers/accounting";
import { useAccounts } from "@hooks/useAccounts";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import styles from "./AccountingPageFilters.module.scss";

type AccountingReportFilters = Pick<FiltersTypes, "accountCodes" | "entityId">;

export const AccountCodeFilterLabel: React.FC<AccountingReportFilters> = ({
    accountCodes,
    entityId,
}) => {
    const { accountsByCode } = useAccounts({ entityId });
    const showAccountNumbers = useShowAccountNumbers();

    if (accountCodes?.length === 1) {
        const account = accountsByCode[String(accountCodes[0])];

        if (!account) {
            return null;
        }

        return (
            <span className={styles.accountCodeFilterLabel}>
                {displayAccountLabel(account, showAccountNumbers)}
            </span>
        );
    }

    return (
        <>
            {accountCodes?.length}{" "}
            {pluralize("Account", accountCodes?.length ?? 0)}
        </>
    );
};
